import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

import JobMessages from '../../../../../JobMessages/Index'
import Refunds from './components/Refunds/Index'
import ProfessionalFeedback from './components/ProfessionalFeedback/Index'

export default {
    name: 'JobDetails',
    computed,
    data,
    methods,
    mounted,
    components: {
        JobMessages,
        Refunds,
        ProfessionalFeedback
    }
}
